import { useSelector } from "react-redux";
import { CreateCharge } from "../../../store/charge-store/charge-actions"; 
import ChargeForms from "../../../components/Forms/ChargeForms";
import { GetCharges } from "../../../store/charge-store/charge-actions";
import { getTokenInfo } from "../../../utils/Guard";

const ChargeCreate = () => {
  const userInfo = getTokenInfo();
  const charge = useSelector((state) => state.charge.charge);
  


  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "37.1rem" }}>
      <ChargeForms actionCharge={CreateCharge} charge={charge} />
      </div>
    </>
  );
};
export default ChargeCreate;
